import * as types from '../constants/actionTypes'

export interface ModalState {
  currentModal: string | null
}
const initialState: ModalState = {
  currentModal: null,
}

export const modalsState = (state: ModalState = initialState, action) => {
  switch (action.type) {
    case types.ShowCreateTicket:
      return {
        ...state,
        currentModal: types.ShowCreateTicket,
      }

    case types.ShowResolveConv:
      return {
        ...state,
        currentModal: types.ShowResolveConv,
      }

    case types.ShowAnalyticsModal:
      return {
        ...state,
        currentModal: types.ShowAnalyticsModal,
      }

    case types.HideModal:
      return {
        ...state,
        ...initialState,
      }

    default:
      return {
        ...state,
      }
  }
}

export const modals = modalsState
